import { ChangeDetectorRef, Injectable, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { HuronMappingPageComponent } from 'src/shared/admin-page/mapping-page.component';
import { MappingEntityInterface } from './mapping-entity.interface';
import { MappingServiceInterface } from './mapping-service.interface';

@Injectable()
export abstract class MappingComponentBase {
    @ViewChild(HuronMappingPageComponent) protected mappingComponent: HuronMappingPageComponent;
    @ViewChild('mappingForm') public mappingForm: NgForm;
  
    public abstract getDisplayName(mapping: MappingEntityInterface): string;

    constructor(protected _mappingService: MappingServiceInterface,
        protected _changeDetector: ChangeDetectorRef) { 
    }

    // Prevent "Expression has changed after it was checked" error
    ngAfterViewChecked(): void {
        this._changeDetector.detectChanges();
    }
}
